module.exports = __webpack_public_path__ + "static/corezoid-1b8c48fcca9ee5fd0ad0f4ad15f12e78.webp";